import { useMemo } from 'react';
import usePermissionStore from './store/usePermissionStore';
import { PermissionName } from '../components/permission/permissionsConstants';

export const usePermission = () => {
  const {
    userPermissions,
    isLoading,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  } = usePermissionStore();

  return useMemo(() => ({
    userPermissions,
    isLoading,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  }), [userPermissions, isLoading, hasPermission, hasAnyPermission, hasAllPermissions]);
};

export const useHasPermission = (permission: PermissionName) => {
  const { hasPermission } = usePermissionStore();

  return useMemo(() => {
    return hasPermission(permission);
  }, [permission, hasPermission]);
};
 
export const useHasAnyPermission = (permissions: PermissionName[]) => {
  const { hasAnyPermission } = usePermissionStore();

  return useMemo(() => {
    return hasAnyPermission(permissions);
  }, [permissions, hasAnyPermission]);
};

export const useHasAllPermissions = (permissions: PermissionName[]) => {
  const { hasAllPermissions } = usePermissionStore();

  return useMemo(() => {
    return hasAllPermissions(permissions);
  }, [permissions, hasAllPermissions]);
};

export default usePermission;

